export enum ReportsActionTypes {
  SEND_DRIVERS_REPORT_REQUEST = 'SEND_DRIVERS_REPORT_REQUEST',
  SEND_DRIVERS_REPORT_END = 'SEND_DRIVERS_REPORT_END',
  SEND_DRIVERS_REPORT_FAILURE = 'SEND_DRIVERS_REPORT_FAILURE',

  SEND_VEHICLES_REPORT_REQUEST = 'SEND_VEHICLES_REPORT_REQUEST',
  SEND_VEHICLES_REPORT_END = 'SEND_VEHICLES_REPORT_END',
  SEND_VEHICLES_REPORT_FAILURE = 'SEND_VEHICLES_REPORT_FAILURE',

  DOWNLOAD_INCIDENTS_REPORT_REQUEST = 'DOWNLOAD_INCIDENTS_REPORT_REQUEST',
  DOWNLOAD_INCIDENTS_REPORT_END = 'DOWNLOAD_INCIDENTS_REPORT_END',
}
